const baseUrl = window?.__RUNTIME_CONFIG__?.REACT_APP_API_HOST
// const baseUrl = "http://188.166.216.116:3000";
const version_app = window?.__RUNTIME_CONFIG__?.REACT_APP_VERSION_APP || "1.0.0";
export { baseUrl, version_app };
